module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kaiseraugst_AG-ddb45b25814bc872f6ee4b1e17397714.svg";